<template>
  <div>
    <v-layout>
      <v-flex xs5 class="mt-2 mb-4 ml-4">
        <v-layout>
          <v-flex xs-3>
            <v-text-field
              append-icon="search"
              label="Template Key"
              single-line
              hide-details
              v-model="filter.key"
            />
          </v-flex>
          <v-spacer/>
          <v-flex xs-3 offset-xs1>
            <v-text-field
              append-icon="search"
              label="Category"
              single-line
              hide-details
              v-model="filter.category"
            />
          </v-flex>
        </v-layout>
      </v-flex>
       <v-flex xs12 sm6>
      <v-btn
        class="ma-3"
        color="primary"
        @click="openModal"
        :disabled="!isWriteAvailable"
      >
        Add Email Template
      </v-btn>
    </v-flex>
    </v-layout>

    <!-- TABLE -->

    <v-data-table
      v-if="emailTemplates"
      :headers="headers"
      :items="emailTemplates"
      class="elevation-1 wrap"
      :pagination.sync="pagination"
      :loading="loading"
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <td class="py-2">{{props.item.templateKey}}</td>
        <td class="py-2">{{props.item.category}}</td>
        <td class="py-2">{{props.item.subject}}</td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="success"
              fab flat
              slot="activator"
              @click.stop="openModal(props.item)"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="error"
              fab flat
              slot="activator"
              @click.stop="deletedEmailTemplatesList(props.item.templateKey, props.item.culture)"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab flat
              slot="activator"
              @click.stop="preview(props.item.body)"
            >
              <v-icon>remove_red_eye</v-icon>
            </v-btn>
            <span>Preview</span>
          </v-tooltip>
        </td>
      </template>
      <!--<template slot="pageText" slot-scope="{}">-->
        <!--Page ! {{pagination.page}} of {{emailTemplates.length}}-->
      <!--</template>-->
    </v-data-table>

    <v-dialog persistent v-model="previewModal" max-width="900px">
      <v-card>
        <v-card-text>
          <div
            class="email-template__border"
            v-html="selectedEmailToPreview"
          />
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="blue darken-1" flat @click.stop="closePreviewModal">Cancel</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent v-model="modalWindow" max-width="1000px">
      <v-card>
        <v-flex xs10 offset-xs1>
          <v-card-title>
            <span class="headline pt-4"> {{typeAction}} Email Template </span>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap mb-5>
              <p>
                Email templates use <a href="https://www.w3schools.com/asp/razor_intro.asp" target="_blank">Razor templates</a>
              </p>
              <p>
                Email template may contain dynamic text like name of Attendee, Price of package etc. to put this data in email template you should use special keyword @Model.variabame avoid writing this manualy use special buttons on the right column to copy variable name in to buffer and then just paste text.
              </p>
              <p>
                Hover by mouse ove variable name and you will see special description about which type data this variable contains.
              </p>
              <p>
                Please note that some variable not just a text, but a complex data sctructures. You should use <a href="https://www.w3schools.com/asp/showfile_c.asp?filename=try_razor_cs_006" target="_blank">special iteration syntax for arrays</a> and if data is an Object you may access subvariable by @Model.VariableName.PropertyName
              </p>
            </v-layout>
            <v-layout row wrap>
              <v-flex column xs5>
                <v-flex>
                  <content-field
                    v-if="editedItem === -1"
                    label="Template Key "
                    v-model="items.templateKey"
                    @input="$v.items.templateKey.$touch"
                    @blur="$v.items.templateKey.$touch"
                    :error="$v.items.templateKey"
                  />
                </v-flex>
                <v-flex>
                  <v-select
                    label="Category"
                    v-model="items.category"
                    item-value="category"
                    item-text="title"
                    :items="emailTempateCategories"
                    :error-messages="isValid($v.items.category)"
                  />
                  <!-- <content-field
                    label="Category"
                    v-model="items.category"
                    @input="$v.items.category.$touch"
                    @blur="$v.items.category.$touch"
                    :error="$v.items.category"
                  /> -->
                </v-flex>
                <v-flex>
                  <content-field
                    label="Subject"
                    v-model="items.subject"
                    @input="$v.items.subject.$touch"
                    @blur="$v.items.subject.$touch"
                    :error="$v.items.subject"
                  />
                </v-flex>
                <!--
                  TODO: CHOOSING HEADER THEME DISABLED ONLY FOR CYPRUS EVENT
                  <v-flex>
                  <v-select
                    :items="headerThemes"
                    v-model="chosenHeaderTheme"
                    item-value="value"
                    item-text="label"
                    label="Select header theme"
                    required
                  />
                </v-flex> -->
                <v-flex>
                  <v-checkbox
                    label="Mobile mode"
                    v-model="isMobileMode"
                  />
                </v-flex>
              </v-flex>
              <v-flex xs5 offset-xs1>
                <v-flex class="py-2">
                  <h4>Description category:</h4>
                  <p>
                    {{ getDescriptionCategory }}
                  </p>
                </v-flex>
                <h3 v-if="modelOfCurrectCategory.length">
                  Model Variables
                </h3>

                <v-flex mt-3>
                  <v-layout
                    v-for="modelVar in modelOfCurrectCategory"
                    :key="modelVar.name"
                    align-content-center
                    justify-space-between
                    row
                  >
                    <v-layout
                      align-content-center
                      justify-start
                    >
                      <div class="centered-var-label">
                        <v-tooltip bottom>
                          <v-flex
                            slot="activator"
                          >
                            <h4>{{ `@Model.${modelVar.name}` }}</h4>
                          </v-flex>
                          <span>{{ modelVar.description }}</span>
                        </v-tooltip>
                      </div>
                    </v-layout>
                    <v-layout
                      align-content-center
                      justify-end
                    >
                      <v-btn
                        fab
                        dark
                        small
                        color="primary"
                        v-clipboard:copy="`@Model.${modelVar.name}`"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >
                        <v-icon dark>content_copy</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-layout>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout align-center wrap>
              <v-flex xs12>
                <content-editor
                  v-model="items.body"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>

            <v-btn
              color="error darken-1"
              @click.stop="closeModal"
            >
              Cancel
            </v-btn>
            <v-spacer/>
            <v-btn
            color="success darken-1"
            @click.stop="save"
            >
              Save
            </v-btn>

          </v-card-actions>
        </v-flex>
        <v-layout
          align-content-center
          justify-center
        >

          <div
            :class="stylesForTemplatePreview"
            v-html="templateForPreview"
          />

        </v-layout>
      </v-card>
    </v-dialog>

    <edit-email-template
      v-if="isShowEditEmailTemplate"
    />

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { required } from 'vuelidate/lib/validators'
  import EditEmailTemplate from './editEmailTemplate'
  import { clone, pathOr } from 'ramda'
  import mixins from '@/utils/mixins'
  import * as R from 'ramda'
  import { emailTempateCategories, escaping, unescaping } from '@/utils/emailTemplates'

  export default {
    name: 'email-template',
    components: {
      EditEmailTemplate
    },
    mixins: [mixins.isWriteAvailable],
    data () {
      return {
        emailTempateCategories,
        pagination: {
          rowsPerPage: 5
        },
        loading: false,
        editedItem: null,
        ready: false,
        items: {
          category: emailTempateCategories[0].category,
          templateKey: '',
          subject: '',
          body: ''
        },
        selectedEmailToPreview: '',
        defaultItems: {
          templateKey: '',
          category: emailTempateCategories[0].category,
          culture: 'en-US',
          subject: '',
          body: ''
        },
        filter: {
          key: '',
          category: ''
        },
        /* eslint-disable */
        modalWindow: false,
        previewModal: false,
        /* eslint-enable */

        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'general_settings:write',
        chosenHeaderTheme: 'general',
        arrayEmailTemplates: [],
        headerThemes: [
          {
            value: 'general',
            label: 'General'
          },
          {
            value: 'awards',
            label: 'Awards'
          },
          {
            value: 'blitz',
            label: 'Blitz'
          }
        ],
        headers: [
          { text: 'Template key', value: 'templateKey', search: true, sortable: true, width: 100 },
          { text: 'Category', value: 'category', search: true, sortable: true, width: 100 },
          { text: 'Subject', value: 'subject', search: true, sortable: true, width: 100 },
          { text: 'Edit', search: false, sortable: false, align: 'center', width: 50 },
          { text: 'Delete', search: false, sortable: false, align: 'center', width: 50 },
          { text: 'Preview', search: false, sortable: false, align: 'center', width: 50 }
        ],
        isMobileMode: false
      }
    },
    validations: {
      items: {
        templateKey: {
          required
        },
        category: {
          required
        },
        subject: {
          required
        }
      }
    },
    computed: {
      ...mapGetters([
        'getEmailTemplates',
        'emailTemplateLayout',
        'isDeveloper',
        'getSettings'
      ]),
      isShowEditEmailTemplate () {
        return this.isDeveloper && this.getSettings
      },
      typeAction () {
        return this.editedItem === -1 ? 'Add' : 'Edit'
      },
      emailTemplates () {
        let unescapeBody = (obj) => Object.assign({}, obj, { body: this.unescaping(obj.body) })
        let unescapedList = this.arrayEmailTemplates.map(unescapeBody)
        unescapedList = unescapedList.map((template) => {
          const arr = template.body.split('<div class="cool-divider"></div>')
          template.body = arr[1] ? arr[1] : arr[0]
          return template
        })
        return unescapedList
      },
      stylesForTemplatePreview () {
        return [
          'template-preview',
          {
            'template-mobile-mode': this.isMobileMode
          }
        ]
      },
      templateForPreview () {
        const emailTemplateWithBody = this.emailTemplateLayout
          ? this.emailTemplateLayout.replace(/\{\{([^}]+)\}\}/g, pathOr('', ['body'], this.items))
          : ''
        return this.unescaping(emailTemplateWithBody)
      },
      getDescriptionCategory () {
        const getDescription = R.compose(
          R.propOr('', 'description'),
          R.find(R.propEq('category', this.items.category))
        )
        return getDescription(emailTempateCategories)
      },
      modelOfCurrectCategory () {
        const getModel = R.compose(
          R.propOr([], 'model'),
          R.find(R.propEq('category', this.items.category))
        )
        return getModel(emailTempateCategories)
      }
    },
    watch: {
      getEmailTemplates: {
        handler (val) {
          this.arrayEmailTemplates = clone(val)
          this.filteredEmailTemplates()
        },
        immediate: true
      },
      modalWindow (val) {
        if (!val) this.closeModal()
      },
      'filter.category' () {
        this.filteredEmailTemplates()
      },
      'filter.key' () {
        this.filteredEmailTemplates()
      },
      isMobileMode () {
        this.toggleEmailBodyStyles()
      }
    },
    methods: {
      ...mapActions([
        'postEmailTemplates',
        'updateEmailTemplates',
        'deleteEmailTemplates',
        'fetchEmailTemplates',
        'showResultSuccessMessage',
        'showResultErrorMessage'
      ]),
      escaping,
      unescaping,
      onCopy () {
        this.showResultSuccessMessage('The Variable Name was added to clipboard.')
      },
      onError () {
        this.showResultErrorMessage()
      },
      isValid (validationItem) {
        return validationItem.$dirty && validationItem.$invalid
          ? ['This field is required']
          : []
      },
      openModal (item) {
        this.editedItem = this.emailTemplates.indexOf(item)
        Object.assign(this.items, this.defaultItems, item)
        this.modalWindow = true
      },
      filteringTemplates (value, filterBy, templates) {
        return templates.filter(template => template[filterBy].toLowerCase().includes(value.toLowerCase()))
      },
      filteredEmailTemplates () {
        const templatesFilteredByCategory = this.filteringTemplates(this.filter.category, 'category', this.getEmailTemplates)
        this.arrayEmailTemplates = this.filteringTemplates(this.filter.key, 'templateKey', templatesFilteredByCategory)
      },
      closeModal () {
        this.$v.items.$reset()
        this.items = Object.assign({}, this.defaultItems)
        this.modalWindow = false
      },
      preview(body) {
        this.selectedEmailToPreview = body
        this.previewModal = true
      },
      closePreviewModal () {
        this.selectedEmailToPreview = ''
        this.previewModal = false
      },
      save () {
        this.$v.items.$touch()
        if (this.$v.items.$invalid) return
        // const template = this.headerContent(this.chosenHeaderTheme) + this.items.body + this.footerContent()
        // this.items.body = this.escaping(template)
        this.items.body = this.escaping(this.items.body)
        if (this.editedItem > -1) {
          this.update(this.items)
        } else {
          this.add(this.items)
        }
      },
      async add (item) {
        try {
          await this.postEmailTemplates({ ...item })
          this.closeModal()
        } catch (err) {
          console.log(err)
        }
      },
      async update (item) {
        try {
          await this.updateEmailTemplates({ ...item })
          this.closeModal()
        } catch (err) {
          console.log(err)
        }
      },
      async deletedEmailTemplatesList (key, culture) {
        try {
          await this.deleteEmailTemplates({ key, culture })
        } catch (err) {
          console.log(err)
        }
      },
      toggleEmailBodyStyles () {
        if (this.isMobileMode) {
          document.querySelector('.jodit_container').style.width = '400px'
          document.querySelector('.jodit_wysiwyg > div').style.width = '350px'
        } else {
          document.querySelector('.jodit_container').style.width = '100%'
          document.querySelector('.jodit_wysiwyg > div').style.width = '100%'
        }
      }
    }
  }
</script>

<style scoped>
  .email-template__border {
    border: 2px solid blueviolet;
    padding: 10px;
  }

  .template-preview {
    padding: 30px 0;
  }

  .template-mobile-mode {
    max-width: 320px;
    margin: 0 auto;
    overflow: hidden;
  }

  .centered-var-label {
    align-self: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/EmailTemplate/index.vue